import { SearchProps } from '~components/form-fields/search';

import { selectLookupAppointmentServiceTypes } from '~appointments/selectors/serviceTypes';
import { selectAppointmentStatuses } from '~appointments/selectors/statuses';
import { selectClientPackages } from '~main/selectors/clients/clientPackages';
import { isEncryptionEnabled } from '~libs/encryptionSettings';

const fields: SearchProps = {
  text_search: {
    persist: true,
    type: 'text-like',
    field: ['client.full_name', 'user.full_name', 'client.referrer_name'],
    placeholder: 'Basic search',
    hidden: isEncryptionEnabled,
  },
  client_name: {
    type: 'text-like',
    field: 'client.full_name',
    placeholder: 'Search client',
    caption: 'Client',
    hidden: isEncryptionEnabled,
  },
  reference_number: {
    type: 'text-like',
    field: 'reference_number',
    placeholder: 'Search reference',
    caption: 'Reference',
  },
  worker_name: {
    type: 'text-like',
    field: 'user.full_name',
    placeholder: 'Search care worker',
    caption: 'Care Worker',
  },
  repeat_start: {
    type: 'date-range',
    field: 'repeat_start',
    caption: 'Repeat Start Date',
  },
  repeat_end: {
    type: 'date-range',
    field: 'repeat_end',
    caption: 'Repeat End Date',
  },
  referrer: {
    type: 'text-like',
    field: 'client.referrer_name',
    caption: 'Referrer',
    placeholder: 'Search Referrer',
  },
  status: {
    type: 'multi-lookup',
    field: 'status_id',
    caption: 'Status',
    placeholder: 'All',
    selectorOptions: selectAppointmentStatuses,
  },
  client_package: {
    type: 'multi-lookup',
    field: 'package_fixed_id',
    caption: 'Package',
    placeholder: 'All',
    selectorOptions: selectClientPackages,
  },
  service_type: {
    type: 'multi-lookup',
    field: 'service_type_id',
    caption: 'Service Type',
    placeholder: 'All',
    selectorOptions: selectLookupAppointmentServiceTypes,
  },
};

export default fields;
